import Slider from "react-slick";
import classNames from "classnames";
import { MarketingEvent } from '../../../types/marketing/MarketingEvent';
import { Preloader } from '../../common';
import { FallbackImage } from '../../common/ImageLoader';
import { EventWidget } from './EventWidget';
import IconSVG from "../../../styles/svg-icons";

interface EventsSectionProps {
    events: MarketingEvent[];
    isLoading: boolean;
}

export const EventsSection = ({ events, isLoading }: EventsSectionProps) => {
    if (isLoading) {
        return (
            <div className="event-row-loader">
                <Preloader inProgress />
            </div>
        );
    }

    const renderFallback = () => (
        <div className="event-item">
            <div className="event-image event-image-wrap">
                <div className="event-image-fallback">
                    {FallbackImage}
                    <p>Webinars, Conferences, New Features, and Improvements are not available for display at the moment.</p>
                </div>
            </div>
        </div>
    );

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        arrows: true,
        nextArrow: <div><IconSVG name="icon-expand" width={16} height={16} /></div>,
        prevArrow: <div><IconSVG name="icon-expand" width={16} height={16} /></div>,
        disabled: events.length < 5
    };

    return (
        <div className="event-row-wrap">
            <div className={classNames("event-row", {
                "event-row-slider": events.length >= 5,
                "event-row-without-slider": events.length < 5,
            })}>
                {events.length
                    ? (
                        <Slider {...settings}>
                            {
                                events.map((event, index) => (
                                    <EventWidget key={`${event.type}-${index}`} event={event} />
                                ))
                            }
                        </Slider>
                    ) 
                    : renderFallback()
                }
            </div>
        </div>
    );
};
